import { useQuery } from "@tanstack/react-query";
import { SubModel } from "model";

import { fetchPreferredSubs, type FetchPreferredSubsFn, type PreferredSubRequest } from "~utils";

type useSubsProps = {
  query: string;
  request: PreferredSubRequest;
  fetchFn?: FetchPreferredSubsFn;
  enabled?: boolean;
};

export const useSubs = ({
  request,
  fetchFn = fetchPreferredSubs,
  query,
  enabled = true,
}: useSubsProps) => {
  const { isError, data: subs } = useQuery<SubModel[]>({
    queryKey: ["subs", "preferred", request, query],
    queryFn: async () => {
      if (!request.school) return [];

      const data = await fetchFn({ req: request, query });
      return data?.data?.map((sub) => new SubModel(sub)) || [];
    },
    staleTime: Infinity,
    enabled,
  });

  return { isError, subs };
};
